import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportLeadsApi, fetchCrmFieldsApi, fetchTasksApi, getConversationApi, saveConversationApi } from "../../../apiservice/crm";
import { Button, Card, Drawer, Input, message, Modal, Select, Typography, Tooltip, Grid, Checkbox, Dropdown,} from "antd";
import { UnorderedListOutlined, AppstoreOutlined, SearchOutlined, FilterOutlined, QuestionCircleOutlined, SortAscendingOutlined, ArrowLeftOutlined, SettingOutlined, UploadOutlined, DownloadOutlined, PlusOutlined,} from "@ant-design/icons";
import { createLead, fetchLeads } from "./leadThunk";
import LeadTable from "./components/LeadTable";
import LeadFilters from "./components/LeadFilters";
import { getAccessType, isAdmin } from "../../../lib/functions";
import { fetchUsers } from "../../../store/commonThunks/lookups";
import LeadList from "./components/LeadList";
import LeadFilterDrawer from "./components/LeadFilterDrawer";
import ReactPhoneInput from "react-phone-input-2";
import "./leadStyle.css";
import "../crmHeaderCard.css";
import "../crmSharedStyle.css";
import { getISOFromCountryName } from "../../../lib/currency";
import { selectAuthInfo } from "../../Auth/authSelectors";
import parsePhoneNumberFromString from "libphonenumber-js";
import { resolveDialableNumber } from "../../../lib/phone";
import PhoneInput from "react-phone-input-2";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import LeadDrawer from "./components/LeadDrawer";
import PipelineView from "./components/PipelineView";
import LeadActivityModal from "./components/LeadActivityModal";
import LeadSortDrawer from "./components/LeadSortDrawer";
import LeadImportModal from "./components/LeadImportModal";
import { resetLeadFilterState, resetLeadSearchFilter, resetVisibleColumns, setLeadFilterState, setVisibleColumns } from "./leadSlice";

const { Title } = Typography;

const Leads = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const location = useLocation();
  const { list, createLoading, filterState, loading, visibleColumns } = useSelector((state) => state.leads);
  const users = useSelector((s) => s.lookups.users);
  
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

const [entryModal, setEntryModal] = useState(false);
const [viewModal, setViewModal] = useState(false);
const [selectedLead, setSelectedLead] = useState(null);
const [conversationText, setConversationText] = useState("");
const [conversations, setConversations] = useState([]);
const [saving, setSaving] = useState(false);
const [access_type, access_type_set] = useState("");
const [createModal, setCreateModal] = useState({
  open: false,
  statusId: null,
});
const [name, setName] = useState("");
const [phone, setPhone] = useState("");
const [email, setEmail] = useState("");
const [source, setSource] = useState("");
const [status, setStatus] = useState("");
const [selectedUserId, setSelectedUserId] = useState(null);
const [filterOpen, setFilterOpen] = useState(false);
const [sortOpen, setSortOpen] = useState(false);
const [tasks, setTasks] = useState([]);
const [view, setView] = useState("list");
const [listMode, setListMode] = useState("table"); // "table" | "card"
const [helpOpen, setHelpOpen] = useState(false);
const [editDrawer, setEditDrawer] = useState(false);
const [leadFilters, setLeadFilters] = useState({});
const [leadCustomFields, setLeadCustomFields] = useState([]);
const [columnMenuOpen, setColumnMenuOpen] = useState(false);
const [importOpen, setImportOpen] = useState(false);
const [exporting, setExporting] = useState(false);
const DEFAULT_VISIBLE_COLUMNS = [
  "no",
  "name",
  "phone",
  "assigned_to",
  "status",
  "last_updated",
  "actions",
];
// const [visibleColumnKeys, setVisibleColumnKeys] = useState(DEFAULT_VISIBLE_COLUMNS);
const lockedColumns = ["name", "actions"];

const authInfo = useSelector(selectAuthInfo)
const adminUser = isAdmin(authInfo);
const defaultCountry = getISOFromCountryName(authInfo?.country);

const subscriptionPlan = String(authInfo?.subscription || "").toLowerCase();
const isFreeVersion = String(authInfo?.trial_mode || "").toLowerCase() == "yes";

const CRM_LEAD_LIMITS = {
  forthcrm_pro: Infinity,
  forthcrm_standard: 7000,
  forthcrm_basic: isFreeVersion ? 200 : 5000,
};

const leadLimit = CRM_LEAD_LIMITS[subscriptionPlan] ?? Infinity;
const hideAddLead = (list?.length || 0) >= leadLimit;

  useEffect(() => {
    const access = getAccessType("crm_leads");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  // Per the customer requirement: a search should still be showing when the
  // user returns from a lead's detail page (POP -- the lead row's navigate,
  // the detail page's own back arrow, or the browser back button all land
  // here as POP), but a genuinely fresh visit (PUSH -- sidebar, dashboard,
  // any other module) should start clean. location.key === "default" is
  // react-router's own marker for the very first load of the app (e.g. a
  // hard refresh landing directly on this URL) -- that also reports as POP
  // even though nothing was navigated back from, so it's excluded too.
  useEffect(() => {
    const isBackFromDetail = navigationType === "POP" && location.key !== "default";
    if (!isBackFromDetail) {
      dispatch(resetLeadSearchFilter());
    }
  }, [dispatch, navigationType, location.key]);

  useEffect(() => {
    dispatch(fetchLeads(filterState));
  }, [dispatch, filterState]);

  useEffect(() => {
    loadTasks();
  }, []);  

  useEffect(() => {
    const loadLeadFields = async () => {
      try {
        const res = await fetchCrmFieldsApi({ module: "lead" });
        setLeadCustomFields(res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };

    loadLeadFields();
  }, []);
 

const handleAddActivity = (lead) => {
  if (lead.source !== "account") {
    message.warning("Activity only for internal leads");
    return;
  }
  setSelectedLead(lead);
  setEntryModal(true);
};

const handleViewActivity = async (lead) => { 

  // ❌ REMOVE THIS
  // if (lead.source !== "account") return;

  // ✅ OPTIONAL restriction
  if (lead.source === "inquiry") {
    message.warning("No activity for inquiry");
    return;
  }

  setSelectedLead(lead);
  setConversations([]);
  setViewModal(true);

  try {
    const res = await getConversationApi({
      customer_id: lead.id,
    });
    setConversations(res.data || []);
  } catch {
    message.error("Failed to load activity");
  }
};


// Exports the leads matching the current filters (admin only — the server enforces it).
const handleExport = async () => {
  setExporting(true);
  try {
    const res = await exportLeadsApi(filterState || {}, "xlsx");
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leads_export_${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    // error bodies of blob requests arrive as a Blob — read the server message out of it
    let text = err.message;
    try {
      if (err.response instanceof Blob) text = JSON.parse(await err.response.text()).message || text;
    } catch { /* keep the generic message */ }
    message.error(text || "Export failed");
  } finally {
    setExporting(false);
  }
};

const activeFilters = filterState || {};

const hasActiveFilters = Object.entries(activeFilters).some(
  ([key, value]) =>
    key !== "search" &&
    key !== "sort_by" &&
    value !== undefined &&
    value !== null &&
    value !== "" &&
    !(Array.isArray(value) && value.length === 0)
);

const handleApplyFilters = (filters) => {

  dispatch(setLeadFilterState(filters));
  setFilterOpen(false);
};

const handleResetFilters = () => {
  dispatch(resetLeadFilterState());
  setFilterOpen(false);
};

const handleApplySort = (sort) => {
  const updated = {
    ...filterState,
    ...sort,
  };

  dispatch(setLeadFilterState(updated));
  setSortOpen(false);
};

const handleSaveActivity = async () => {
  if (!conversationText.trim()) return;

  setSaving(true);

  try {
    await saveConversationApi({
      customer_id: selectedLead.id,
      text: conversationText,
    });

    message.success("Activity saved ✅");
    setEntryModal(false);
    setConversationText("");
  } catch {
    message.error("Failed to save");
  } finally {
    setSaving(false);
  }
};

const loadTasks = async () => {
  const res = await fetchTasksApi();
  setTasks(res.data || []);
};


  const handleCreate = async () => {
    if (!name || !phone) {
      return message.warning("Name & phone required");
    }

    const parsed = parsePhoneNumberFromString(`+${phone}`);

    if (!parsed || !parsed.isValid()) {
      return message.error("Invalid phone number");
    }

    try {
      await dispatch(
        createLead({
          name,
          phone, // already clean numeric
          email,
          assigned_to: selectedUserId,
          source: "manual",
        })
      ).unwrap();

      message.success("Lead created ✅");

      setCreateModal(false);
      setName("");
      setPhone("");
      setEmail("");
      setSelectedUserId(null);
      
      dispatch(fetchLeads());
    }  catch (err) {
      message.error(
        err?.message ||
        "A lead with this phone number already exists."
    )};
  };

  // Lead Table Options for Column Filter
  const columnOptions = [
    { label: "No", value: "no" },
    { label: "Name", value: "name" },
    { label: "Phone", value: "phone" },
    { label: "Agent", value: "assigned_to" },
    { label: "Source", value: "source" },
    { label: "Purpose", value: "purpose" },
    { label: "Status", value: "status" },
    { label: "Last Updated", value: "last_updated" },
    { label: "Created Date", value: "date" },

    // Every custom field is offered here, not just the ones flagged "Show
    // in list" in CRM Customize -- that setting is only the default, this
    // panel is what actually decides what's visible.
    ...leadCustomFields.map((f) => ({
      label: f.field_name,
      value: `custom_${f.field_key}`,
    })),

    { label: "Actions", value: "actions" },
  ];

  

  return (
    <div className="p-4">
      <Card
        className="shadow-md rounded-xl mb-4 crm-header-card"
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate(-1)} 
                  style={{ marginRight: 8 }}
                />
            <Title level={4} style={{ margin: 0 }}>
              Leads
            </Title>
            </div>

            <Tooltip title="Help">
              <Button
                type="text"
                icon={<QuestionCircleOutlined style={{ fontSize: 17 }} />}
                onClick={() => setHelpOpen(true)}
              />
            </Tooltip>
          </div>
        }
        extra={
     <>  
     {/* <Button onClick={() => setView(view === "list" ? "pipeline" : "list")}>
      {view === "list" ? "Pipeline View" : "List View"}
      </Button>      */}
      <div style={{ display: "flex", gap: !isMobile ? 8 : 2 }}>
      <Button
        type={view === "list" ? "primary" : "default"}
        icon={<UnorderedListOutlined />}
        onClick={() => setView("list")}
      />

      <Button
        type={view === "pipeline" ? "primary" : "default"}
        icon={<AppstoreOutlined />}
        onClick={() => setView("pipeline")}
      />
    
      <Tooltip title="Import leads from a CSV/Excel file">
        <Button icon={<UploadOutlined />} onClick={() => setImportOpen(true)}>
          {!isMobile && "Import"}
        </Button>
      </Tooltip>

      {adminUser && (
        <Tooltip title="Export the leads matching the current filters">
          <Button icon={<DownloadOutlined />} loading={exporting} onClick={handleExport}>
            {!isMobile && "Export"}
          </Button>
        </Tooltip>
      )}

      {!isMobile && (
        <Button type="primary" onClick={() => setCreateModal({open: true})}>
          + Add Lead
        </Button>
      )}
      </div>
    </>   
  }
      />
      

      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>

          <Input
            size="large"
            style={{ flex: "1 1 200px" }}
            placeholder="Search leads..."
            prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
            allowClear
            value={filterState.search || ""}
            onChange={(e) => {
              const val = e.target.value;

              const updated = {
                ...filterState,
                search: val,
              };

              dispatch(setLeadFilterState(updated));
              dispatch(fetchLeads(updated));
            }}
          />

          {/* Lead Table Column filtering */}
          {view === "list" && !isMobile && (
          <Dropdown
            open={columnMenuOpen}
            onOpenChange={setColumnMenuOpen}
            trigger={["click"]}
            dropdownRender={() => (
              <div
                style={{
                  width: 290,
                  background: "#fff",
                  borderRadius: 10,
                  overflow: "hidden",
                  boxShadow: "0 6px 20px rgba(0,0,0,.12)",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    padding: "14px 16px",
                    borderBottom: "1px solid #f0f0f0",
                    fontWeight: 600,
                    fontSize: 15,
                  }}
                >
                  Show / Hide Columns
                </div>

                {/* Body */}
                <div
                  style={{
                    maxHeight: 320,
                    overflowY: "auto",
                    padding: "12px 16px",
                  }}
                >
                  <Checkbox.Group
                    value={visibleColumns}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: 2,
                    }}
                    onChange={(checkedValues) => {
                      const next = Array.from(
                        new Set([...checkedValues, ...lockedColumns])
                      );

                      dispatch(setVisibleColumns(next));
                    }}
                  >
                    {columnOptions.map((col) => (
                      <Checkbox
                        key={col.value}
                        value={col.value}
                        disabled={lockedColumns.includes(col.value)}
                        className="crm-column-toggle-row"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          margin: 0,
                          padding: "6px 8px",
                          borderRadius: 6,
                          fontSize: 14,
                        }}
                      >
                        {col.label}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                </div>

                {/* Footer */}
                <div
                  style={{
                    borderTop: "1px solid #f0f0f0",
                    padding: 12,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 8,
                  }}
                >
                  <Button
                    onClick={() => dispatch(resetVisibleColumns())}
                  >
                    Reset
                  </Button>

                  <Button
                      type="primary"
                      onClick={() => setColumnMenuOpen(false)}
                  >
                      Done
                  </Button>
                </div>
              </div>
            )}
          >
            <Button icon={<SettingOutlined />}>
              Columns
            </Button>
          </Dropdown> )}

          <Button
            icon={<SortAscendingOutlined />}
            onClick={() => setSortOpen(true)}
          />
          <Tooltip
            title={
              hasActiveFilters
                ? "Filters active - click to manage or reset"
                : "Filter leads"
            }
          >
            <Button
              type={hasActiveFilters ? "primary" : "default"}
              icon={<FilterOutlined />}
              onClick={() => setFilterOpen(true)}
            />
          </Tooltip>
      </div>

      <Card loading={loading}>
        {view === "list" ? (
          isMobile ? (
            <LeadList
              list={list}
              tasks={tasks}
              isAdmin={adminUser}              
              onCall={(phone, country) => window.location.href = `tel:${resolveDialableNumber(phone, country)}`}
              onOpen={(lead) => {
                navigate(`/crm/leads/${lead.id}`);
              }}
              onViewActivity={handleViewActivity}
            />
          ) : (
            <LeadTable
              list={list}
              tasks={tasks}
              loading={loading}
              isAdmin={adminUser}
              onAddActivity={handleAddActivity}
              onViewActivity={handleViewActivity}
              setEditDrawer={setEditDrawer}
              setSelectedLead={setSelectedLead}
              selectedLead={selectedLead}
              visibleColumnKeys={visibleColumns}
            />
          )
        ) : (
          <PipelineView setCreateModal={setCreateModal} />
        )}
      </Card>

    <LeadFilterDrawer
      open={filterOpen}
      onClose={() => setFilterOpen(false)}
      onApply={handleApplyFilters}
      onReset={handleResetFilters}
      isAdmin={adminUser}
    />
    <LeadSortDrawer
      open={sortOpen}
      onClose={() => setSortOpen(false)}
      onApply={handleApplySort}
    />

    <LeadImportModal
      open={importOpen}
      onClose={() => setImportOpen(false)}
      onDone={() => dispatch(fetchLeads(filterState))}
      isAdmin={adminUser}
      customFields={leadCustomFields}
    />

      <Modal
        open={entryModal}
        title={`Add Activity - ${selectedLead?.name}`}
        onCancel={() => setEntryModal(false)}
        footer={null}
        >
        <Input.TextArea
            rows={5}
            value={conversationText}
            onChange={(e) => setConversationText(e.target.value)}
        />

        <Button
            type="primary"
            loading={saving}
            onClick={handleSaveActivity}
            block
            style={{ marginTop: 10 }}
        >
            Save
        </Button>
        </Modal>

        <LeadActivityModal
          open={viewModal}
          onClose={() => setViewModal(false)}
          lead={selectedLead}
        />

        {/* <Modal
          open={createModal}
          onCancel={() => setCreateModal(false)}
          title="Create Lead"
          footer={null}
        >
          <Input
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ marginBottom: 10 }}
          />

          <PhoneInput
            country={defaultCountry}
            value={phone}
            onChange={(value) => setPhone(value)}
            inputStyle={{
              width: "100%",
              height: "40px",
              borderRadius: "8px",
            }}
            containerStyle={{ marginBottom: 10 }}
            placeholder="Enter phone number"
          />

          <Input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginBottom: 10 }}
          />
          
          <Select
            placeholder="Assign Agent"
            value={selectedUserId}
            onChange={setSelectedUserId}
            style={{ width: "100%", marginBottom: 10 }}
            options={(users || []).map((u) => ({
              label: u.full_name,
              value: u.id,
            }))}
          />

          <Button type="primary" block onClick={handleCreate}>
            Create Lead
          </Button>
        </Modal> */}

        {/* <Drawer
          title="Create Lead"
          open={createModal}
          onClose={() => setCreateModal(false)}
          width={420}
        >
         
          <Input placeholder="Customer Name" value={name} onChange={(e) => setName(e.target.value)} />

          <PhoneInput
            country={defaultCountry}
            value={phone}
            onChange={(value) => setPhone(value)}
            inputStyle={{
              width: "100%",
              height: "40px",
              borderRadius: "8px",
            }}
            containerStyle={{ marginBottom: 10 }}
            placeholder="Enter phone number"
          />

          <Input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginBottom: 10 }}
          />
          
          <Select
            placeholder="Assign Agent"
            value={selectedUserId}
            onChange={setSelectedUserId}
            style={{ width: "100%", marginBottom: 10 }}
            options={(users || []).map((u) => ({
              label: u.full_name,
              value: u.id,
            }))}
          />

        
          <Select
            placeholder="Lead Source"
            onChange={(v) => setSource(v)}
            options={[
              { label: "Manual", value: "manual" },
              { label: "Inquiry", value: "inquiry" },
              { label: "Campaign", value: "campaign" },
            ]}
          />

          
          <Select
            placeholder="Lead Status"
            onChange={(v) => setStatus(v)}
            options={[
              { label: "New", value: "p" },
              { label: "Contacted", value: "contacted" },
              { label: "Interested", value: "interested" },
            ]}
          />

          
          <Select
            mode="multiple"
            placeholder="Interested Countries"
            options={countryOptions}
          />

          <Button loading={createLoading} type="primary" block onClick={handleCreate}>
            Create Lead
          </Button>
        </Drawer> */}

        {isMobile && (
          <Button
            type="primary"
            shape="circle"
            size="large"
            className="lead-add-fab"
            icon={<PlusOutlined />}
            aria-label="Add Lead"
            onClick={() => setCreateModal({ open: true })}
          />
        )}

        <LeadDrawer
          open={createModal.open || editDrawer }
          mode={editDrawer ? "edit" : "create"}
          lead={selectedLead}
          users={users || []}
          defaultStatus={createModal.statusId} 
          defaultCountry={defaultCountry} 
          onClose={() => {
            setCreateModal({ 
              open: false, 
              statusId: null 
            })
            setEditDrawer(false);
            setSelectedLead(null);
          }}            
        />
      <Drawer
        title="CRM Leads Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={screens.md ? 430 : "100%"}
        className="crm-drawer"
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "12px"
            }}
          >
            CRM Lead Management
          </h2>

          <p style={{ color: "#555", marginBottom: "16px",marginLeft: 17 }}>
            The CRM Leads module is used to manage customer leads, inquiries,
            follow-ups, pipeline tracking, and sales activities within the ERP CRM system.
            It helps organize lead communication, lead status tracking, and sales workflow management.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View leads in List View and Pipeline View</li>
              <li>Create new CRM leads manually</li>
              <li>Search leads using live search filters</li>
              <li>Apply advanced lead filtering options</li>
              <li>Assign leads to sales agents or users</li>
              <li>Track lead statuses and sales stages</li>
              <li>Add lead activity and conversation history</li>
              <li>View previous customer conversations and follow-ups</li>
              <li>Manage inquiry, manual, and campaign leads</li>
              <li>Open detailed lead profile pages</li>
              <li>Track customer communication activities</li>
              <li>Manage sales pipeline workflow visually</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Activities are only available for internal/account leads.</li>
              <li>Inquiry leads may have restricted activity access.</li>
              <li>Phone numbers are validated before lead creation.</li>
              <li>Pipeline View helps monitor sales stages visually.</li>
              <li>Lead activities are stored as conversation history.</li>
              <li>User assignment helps distribute leads between agents.</li>
              <li>Role permissions control CRM access and operations.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Leads;